import React from "react";
import classNames from "classnames";
import { TrackingInfo } from "gpc-shared-types";
import { format } from "date-fns";

export type Props = {
  trackingInfo: TrackingInfo;
  createdDate: string;
  className?: string;
};

export const TrackingStatus = ({
  trackingInfo,
  createdDate,
  className = "",
}: Props) => {
  const internalClassName = classNames("gpc__fulfillment-tracking", className);

  return (
    <div className={internalClassName}>
      <div>{format(new Date(createdDate), "MMMM d, yyyy")}</div>
      <div>
        Tracking number:{" "}
        {trackingInfo.url ? (
          <a href={trackingInfo.url}>{trackingInfo.number}</a>
        ) : (
          <span>{trackingInfo.number}</span>
        )}
      </div>
    </div>
  );
};

export default TrackingStatus;
